import React from 'react';

export const defaultTheme = 'default';

export const DocThemeContext = React.createContext(null);
